import React, { useState } from "react";
import "../../assets/css/Editor.css";
import Editor from "@monaco-editor/react";

const CodeEditor = ({ onChange, language, code, readOnly}) => {
    const [value, setValue] = useState(code || "");
    const options = {
        readonly: readOnly
    };


    const handleEditorChange = (value) => {
        setValue(value);
        if (onChange)
            onChange("code", value);
    };

    return (
        <div className="editor-container form-control">
            <Editor
                language={language || "javascript"}
                value={value}
                theme="vs-dark"
                defaultValue="// some comment"
                onChange={handleEditorChange}
                options={options}
            />
        </div>
    );
};
export default CodeEditor;